module.exports = __webpack_public_path__ + "img/icon8.4079a262.png";